module.exports = __webpack_public_path__ + "static/Autospinn 1.9e3afd68.svg";